import { Button, Grid, Typography } from '@material-ui/core'
import React, { Dispatch } from 'react'
import { OrganizationsClient } from '../generated/ApiClient'
import { Formik, Form, Field } from 'formik'
import { TextField } from 'formik-material-ui'
import * as Yup from 'yup'
import { useDispatch } from "react-redux";
import { actionCreators as snackbar } from '../store/AlertSnackbarStore'
import { RouteComponentProps } from 'react-router'

async function formSubmitCallback(organizationId: string, email: string, dispatch: Dispatch<any>, props: RouteComponentProps<{ organizationId: string }>) {
    try {
        await new OrganizationsClient().addEmail(organizationId, email)
        dispatch(snackbar.addMessage({ title: "Success", message: `Email successfully added`, alertType: 'success' }))
        props.history.push(`/organizations/${organizationId}`);
    }
    catch (error) {
        dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
    }
}

const AddEmailFormSchema = Yup.object().shape({
    email: Yup.string().max(200).required(),
})

type AddEmailFormProperties = Yup.InferType<typeof AddEmailFormSchema>

export default function AddEmailToOrg(props: RouteComponentProps<{ organizationId: string }>) {
    const dispatch = useDispatch();

    return (
        <>
            <Formik initialValues={{ email: "" } as AddEmailFormProperties}
                onSubmit={async (values, _) => formSubmitCallback(props.match.params.organizationId, values.email, dispatch, props)}>
                {/* supply a function to formik so that we can access these props*/}
                {({ submitForm, isSubmitting, touched }) => (
                    <>
                        <Form translate='yes'>
                            <Grid container alignItems='center' spacing={1}>
                                <Grid item>
                                    <Typography paragraph display='inline'><b>Domain or Email Address:</b></Typography>
                                </Grid>
                                <Grid item>
                                    <Field component={TextField} name='email' type='text' />
                                </Grid>
                                <Grid item>
                                    <Typography paragraph variant='body2' display='inline'>Enter an email domain with no '@' prefix or an email address. When matching, the domain will not include the '@' character</Typography>
                                </Grid>
                            </Grid>
                        </Form>
                        <Button variant='contained' color='primary' size='medium' onClick={submitForm}>Add</Button>
                    </>
                )}
            </Formik>
        </>
    )
}